module.exports = __webpack_public_path__ + "static/media/backimage.b70da9db.jpg";